import { useSearchParam } from './useSearchParam';

export const useIsSearchParamPresent = (param: string) => {
  const searchParam = useSearchParam(param);

  return Boolean(searchParam);
};
